"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.LessOrGreaterThan = exports.StyledInput = void 0;
const styles_1 = require("@mui/material/styles");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
exports.StyledInput = (0, styles_1.styled)(TextField_1.default)(({ theme }) => ({
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    width: "75px",
    input: {
        fontWeight: "bold",
        padding: "0px !important",
        color: theme.palette.grayScale.gray2,
    },
    "& .MuiFormHelperText-root.Mui-error": {
        fontSize: "14px",
    },
    "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
    },
}));
exports.LessOrGreaterThan = (0, styles_1.styled)("span")({
    margin: "0 12px",
    fontSize: 16,
    fontWeight: "bold"
});
exports.Wrapper = (0, styles_1.styled)("span")({
    display: "flex",
    justifyContent: "center"
});
